import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

// Css Import
import styles from "./createEventModal.module.css";

// Material Ui Stuff
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Carousel from "react-material-ui-carousel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
    KeyboardDatePicker,
    KeyboardTimePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

// Material Ui Icons
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
        background: "#4E73F8",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    saveButton: {
        color: "#ffffff",
        fontSize: "0.875rem",
        border: "1px solid #ffffff",
        padding: "4px 20px",
    },
    contentContainer: {
        height: "calc(100vh - 64px)",
        overflow: "auto",
        padding: "0px",
    },
    message: {
        marginTop: "1rem",
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function CreateEventModal(props) {
    const [state, setState] = useState({
        images: [
            {
                src: "https://img.freepik.com/free-vector/elegant-event-party-banner-with-black-splash_1361-2171.jpg?size=626&ext=jpg",
            },
            {
                src: "https://img.freepik.com/free-vector/technology-conference-poster-template_1361-1211.jpg?size=626&ext=jpg",
            },
            {
                src: "https://img.freepik.com/free-vector/abstract-technology-conference-template_1361-1213.jpg?size=626&ext=jpg",
            },
        ],
        tags: [],
        addTagText: "",
        name: "",
        description: "",
        isEasyApply: true,
        externalFormLink: "",
        videoLink: "",
        eventType: "Society",
    });

    const classes = useStyles();

    //contains selected time
    const [selectedDate, setSelectedDate] = useState(String(new Date()));

    const handleDateChange = (date) => {
        setSelectedDate(String(date));
    };

    const addTag = (e) => {
        if (
            e.key === "Enter" &&
            state.tags.length <= 4 &&
            state.addTagText.length !== 0
        ) {
            setState((prevState) => ({
                ...prevState,
                tags: [...state.tags, state.addTagText],
                addTagText: "",
            }));
        }
    };

    const handleChange = (e) => {
        setState((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const deleteTag = (index) => {
        state.tags.splice(index, 1);
        setState((prevState) => ({
            ...prevState,
        }));
    };

    const deleteImage = (index) => {
        state.images.splice(index, 1);
        setState((prevState) => ({
            ...prevState,
        }));
    };

    const handleCheckbox = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.name === "isEasyApply" && event.target.checked) {
            setState((prevState) => ({
                ...prevState,
                externalFormLink: "",
            }));
        }
        console.log(state, selectedDate);
    };

    const { openCreateEvent, closeEventCreatorModal } = props;

    const {
        images,
        addTagText,
        name,
        tags,
        description,
        isEasyApply,
        externalFormLink,
        videoLink,
        eventType,
    } = state;

    return (
        <div>
            <Dialog
                fullScreen
                open={openCreateEvent}
                onClose={closeEventCreatorModal}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={closeEventCreatorModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Create Event
                        </Typography>
                        <Button
                            autoFocus
                            className={classes.saveButton}
                            onClick={closeEventCreatorModal}
                        >
                            Save
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.contentContainer}>
                    {/* <DialogContentText className={classes.message}>
                        Images, [ organizationla, society, collegeEvent ]
                    </DialogContentText> */}
                    <main className={styles.container}>
                        <section className={styles.formOuterContainer}>
                            <div className={styles.formGroup}>
                                <label forhtml="" className={styles.heading}>
                                    Add Information
                                </label>
                                <div className={styles.subHeading}>
                                    Enter the required information below to
                                    create a brand new event. You can change it
                                    anytime you want.
                                    <br />
                                    On a large screen you can even see the
                                    preview of the event post which you are
                                    creating at the time of entering different
                                    fields.
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="name"
                                    className={styles.heading}
                                >
                                    Name
                                </label>
                                <div className={styles.inputFieldContainer}>
                                    <input
                                        className={`${styles.inputField} ${styles.editable}`}
                                        type="text"
                                        name="name"
                                        value={name}
                                        onChange={handleChange}
                                        placeholder="Event Name"
                                    />
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label forhtml="" className={styles.heading}>
                                    Choose your main interest
                                </label>
                                <FormControl
                                    className={styles.eventTypeContainer}
                                >
                                    <Select
                                        displayEmpty
                                        inputProps={{
                                            "aria-label": "Without label",
                                        }}
                                        className={styles.eventTypeSelector}
                                        onChange={handleChange}
                                        value={eventType}
                                        name="eventType"
                                    >
                                        <MenuItem
                                            className={styles.menu}
                                            value={"Society"}
                                        >
                                            Society Related Event
                                        </MenuItem>
                                        <MenuItem
                                            className={styles.menu}
                                            value={"Organizational"}
                                        >
                                            Organization Related Event
                                        </MenuItem>
                                        <MenuItem
                                            className={styles.menu}
                                            value={"College"}
                                        >
                                            College Related Event
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="name"
                                    className={styles.heading}
                                >
                                    Event Date
                                </label>
                                <div className={styles.inputFieldContainer}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                    >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            format="MM/dd/yyyy"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="name"
                                    className={styles.heading}
                                >
                                    Event Time
                                </label>
                                <div className={styles.inputFieldContainer}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                    >
                                        <KeyboardTimePicker
                                            margin="normal"
                                            id="time-picker"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            KeyboardButtonProps={{
                                                "aria-label": "change time",
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="name"
                                    className={styles.heading}
                                >
                                    Tags
                                </label>
                                <div className={styles.inputFieldContainer}>
                                    <input
                                        className={`${styles.inputField} ${styles.editable}`}
                                        type="text"
                                        name="addTagText"
                                        placeholder="Event tags"
                                        onKeyPress={addTag}
                                        value={addTagText}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div
                                    className={`${styles.formTagsContainer} ${
                                        tags.length === 0
                                            ? styles.hidden
                                            : styles.block
                                    }`}
                                >
                                    {tags.map((each, index) => {
                                        return (
                                            <span className={styles.singleTag}>
                                                {each}{" "}
                                                <span
                                                    title="Delete Technology"
                                                    onClick={() =>
                                                        deleteTag(index)
                                                    }
                                                    className={
                                                        styles.deleteTagButton
                                                    }
                                                >
                                                    X
                                                </span>
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="description"
                                    className={styles.heading}
                                >
                                    Description
                                </label>
                                <div className={styles.inputFieldContainer}>
                                    <TextareaAutosize
                                        name="description"
                                        value={description}
                                        onChange={handleChange}
                                        rowsMin={5}
                                        placeholder="Minimum 5 rows"
                                        className={styles.eventDescriptionInput}
                                    />
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="isEasyApply"
                                    className={styles.heading}
                                >
                                    Images
                                </label>
                                <div className={styles.subHeading}>
                                    Add poster, banner, etc. (max 3 images)
                                </div>
                                <div className={styles.inputFieldContainer}>
                                    <button>Upload Images</button>
                                    <div
                                        className={styles.imagePreviewContainer}
                                    >
                                        {images.map((each, index) => {
                                            return (
                                                <div>
                                                    <img
                                                        src={each.src}
                                                        alt="banner"
                                                        key={index}
                                                    />
                                                    <button
                                                        onClick={() =>
                                                            deleteImage(index)
                                                        }
                                                    >
                                                        X
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="isEasyApply"
                                    className={styles.heading}
                                >
                                    Video Link
                                </label>
                                <div className={styles.subHeading}>
                                    Link of any event related video (Not
                                    Mandatory)
                                </div>
                                <div className={styles.inputFieldContainer}>
                                    <input
                                        className={`${styles.inputField} ${styles.editable}`}
                                        type="text"
                                        name="videoLink"
                                        value={videoLink}
                                        onChange={handleChange}
                                        placeholder="https://videolink.co/example"
                                    />
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label
                                    forhtml="isEasyApply"
                                    className={styles.heading}
                                >
                                    Add Application Form
                                </label>
                                <div className={styles.subHeading}>
                                    <b>Selecting easy apply </b> makes it easier
                                    for students to fill the form with just a
                                    single click.
                                    <br />
                                    <b>Note: </b>You will receive only these
                                    details if you select EASY APPLY.
                                    <br />
                                    <i>
                                        1. Name, 2. Email, 3. PhoneNo, 4.
                                        Branch, 5. Batch
                                    </i>
                                </div>
                                <div className={styles.inputFieldContainer}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isEasyApply}
                                                onChange={handleCheckbox}
                                                name="isEasyApply"
                                            />
                                        }
                                        label="Easy Apply"
                                    />
                                </div>
                            </div>

                            {!isEasyApply && (
                                <div className={styles.formGroup}>
                                    <label
                                        forhtml="externalFormLink"
                                        className={styles.heading}
                                    >
                                        Add External Form Link
                                    </label>
                                    <div className={styles.inputFieldContainer}>
                                        <input
                                            className={`${styles.inputField} ${styles.editable}`}
                                            type="text"
                                            name="externalFormLink"
                                            value={externalFormLink}
                                            onChange={handleChange}
                                            placeholder="https://externalFormLink.com"
                                        />
                                    </div>
                                </div>
                            )}
                        </section>
                        <section className={styles.outputOuterContainer}>
                            <div className={styles.eventCard}>
                                <header className={styles.eventCardHeader}>
                                    <div className={styles.eventCardHeaderLeft}>
                                        <h1>
                                            {name.length === 0
                                                ? "Event Name"
                                                : name}
                                        </h1>
                                        <span>
                                            {selectedDate.length === 0
                                                ? "Upcoming Event"
                                                : `${new Date(
                                                      selectedDate
                                                  ).toDateString()} | ${new Date(
                                                      selectedDate
                                                  ).toLocaleTimeString("en", {
                                                      timeStyle: "short",
                                                      hour12: true,
                                                  })}`}
                                        </span>
                                    </div>
                                    <div
                                        className={styles.eventCardHeaderRight}
                                    >
                                        {eventType === "Society" && (
                                            <>
                                                <span>TechSoc</span>
                                                <img
                                                    src="https://img.freepik.com/free-vector/technology-conference-poster-template_1361-1211.jpg?size=626&ext=jpg"
                                                    alt=""
                                                />
                                            </>
                                        )}
                                    </div>
                                </header>
                                <Carousel
                                    NextIcon={
                                        <ArrowForwardIosIcon
                                            style={{
                                                width: "10px",
                                                height: "10px",
                                            }}
                                        />
                                    }
                                    PrevIcon={
                                        <ArrowBackIosIcon
                                            style={{
                                                width: "10px",
                                                height: "10px",
                                            }}
                                        />
                                    }
                                    animation="slide"
                                    swipe={true}
                                    indicators={false}
                                    navButtonsAlwaysVisible={false}
                                >
                                    {state.images.map((item, i) => (
                                        <Item key={i} item={item} />
                                    ))}
                                </Carousel>
                                <section className={styles.applicationButtons}>
                                    <h2>Application</h2>
                                    {isEasyApply && <button>Easy Apply</button>}
                                    {!isEasyApply && (
                                        <a
                                            rel="noreferrer"
                                            target="_blank"
                                            href={externalFormLink}
                                        >
                                            Fill Form
                                        </a>
                                    )}
                                </section>
                                <Accordion
                                    className={styles.eventDescriptionContainer}
                                >
                                    <AccordionSummary
                                        className={
                                            styles.eventDescriptionHeadingContainer
                                        }
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <h1
                                            className={
                                                styles.eventDescriptionHeading
                                            }
                                        >
                                            Event Description
                                        </h1>
                                    </AccordionSummary>
                                    <AccordionDetails
                                    // className={
                                    //     styles.eventDescriptionHeadingContainer
                                    // }
                                    >
                                        <div className={styles.description}>
                                            <p>
                                                {description.length === 0
                                                    ? "Add some basic details about the event. How it will happen? What things will be most important. Is this an event for all college students or a specific branch or section?"
                                                    : description}
                                                {videoLink && (
                                                    <a
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        href={videoLink}
                                                        className={
                                                            styles.videoLink
                                                        }
                                                    >
                                                        Related Video...
                                                    </a>
                                                )}
                                            </p>
                                            <div className={styles.eventTags}>
                                                {tags.map((each, index) => {
                                                    return (
                                                        <span key={index}>
                                                            {each}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </section>
                    </main>
                </DialogContent>
            </Dialog>
        </div>
    );
}

function Item(props) {
    return (
        <img
            style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
            }}
            src={props.item.src}
            alt=""
        />
    );
}

export default CreateEventModal;
